<template>
    <div class="course_list_content use_common" :class="{course_content_hidden: isFixedHeight, course_content_bottom: !isBeginActivity, course_list_content_top: navNumberList.length > 0, course_content_bottom_iphoneX: isIphoneX}">
        <!--活动未结束-->
        <div v-if="!isEndActivity" v-cloak>
            <div class="title_content flex_box" :class="{title_content_left: (navNumberShowString.length <= 1 && !selectNavString) || (navNumberList.indexOf(3) === -1 && navNumberList.length===1)}" v-if="navNumberList.length > 0">
                <div class="title_name_content flex_box" @click="selectSchoolType(1)" v-if="navNumberList.indexOf(0) > -1">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 1}">{{schoolName || '校区'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 1 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
                <div class="title_name_content flex_box" @click="selectSchoolType(2)" v-if="navNumberList.indexOf(1) > -1">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 2}">{{gradeName || '年级'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 2 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
                <div class="title_name_content flex_box" @click="selectSchoolType(3)" v-if="navNumberList.indexOf(3) > -1 && selectNavString == navNumberShowString">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 3}">{{timeName || '时间'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 3 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
            </div>
            <v-reload
                    :on-infinite-load="onInfiniteLoad"
                    :parent-pull-up-state="pullUpState"
                    :footer-content="isShowPullUpFooter"
            >
                <div class="course_package_list course_package_list_top add_style" v-if="packageList.length">
                    <div class="package_content" v-for="(packageItem, packageIndex) in packageList" :key="packageItem.packageCode" :class="{package_content_bottom: packageList.length !== packageIndex+1}">
                        <div class="package_title flex_box package_title_style">
                            <div class="package_title_text tow">{{packageItem.packageName}}</div>
                            <div class="add_package select_all" @click="selectAll(packageItem)" :class="{add_package_color: packageItem.isSoldOut}">{{packageItem.isSoldOut ? '已报满' : packageItem.isSelectAll ? '取消全选' : '套餐内全选'}}</div>
                        </div>
                        <div class="course_list_details detail_style" v-for="(courseItem, courseIndex) in packageItem.classList" :key="courseIndex" :class="{course_list_details_opacity: courseItem.registrationState===6}" @click="selectCourse(packageItem, courseItem)">
                            <div class="course_name_content">
                                <span class="class_type" v-if="courseItem.seasonName&&courseItem.productType == 1">{{courseItem.seasonName}}</span>
                                <span class="teaching_methods" v-if="courseItem.teachingMethod&&teachingMethod(courseItem.teachingMethod)">{{teachingMethod(courseItem.teachingMethod || '')}}</span>
                                <span class="course_name">{{courseItem.className}}</span>
                            </div>
                            <div class="flex_box class_num_time" v-if="courseItem.productType == 1">
                                <span class="lessons_num">{{courseItem.classCode}}</span>
                                <span class="lessons_num">{{getClassLessonTimes(courseItem.lessonTimes, (courseItem.realMinutes || 0))}}</span>
                                <span class="lessons_num" v-if="getClassStay(courseItem.classMode || '')">住宿班</span>
                                <span class="course_quota" v-if="courseItem.registrationState===1&&isFew((courseItem.maxNum - courseItem.usableCount), courseItem.maxNum, courseItem.registrationState)">名额紧张</span>
                                <span class="course_quota" v-if="courseItem.registrationState===2||courseItem.registrationState===3">已开课/可插班</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===4">已开课</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===6">已报满</span>
                            </div>
                            <div class="flex_box class_num_time" v-else>
                                <span class="lessons_num">{{courseItem.classCode}}</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="learn_place_icon" src="../../assets/cardaddricon.png" />
                                <span class="class_num tow">{{courseItem.learnPlace}}</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="card_year_icon" src="../../assets/cardyearicon.png" />
                                <span class="class_num" v-if="courseItem.productType == 1">{{formatDate(new Date(courseItem.startDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')+'至'+formatDate(new Date(courseItem.endDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')}}</span>
                                <span class="class_num" v-else>{{formatDate(new Date(courseItem.startDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')+'开始'}}</span>
                            </div>
                            <div class="course_details course_time_details">
                                <img class="card_time_icon" src="../../assets/cardtimeicon.png" />
                                <div class="flex_box">
                                    <span class="time_details text_ellipsis_two">{{courseItem.learnTime}}</span>
                                </div>
                            </div>

                            <div class="first_shift_time" v-if="(courseItem.registrationState===2||courseItem.registrationState===3)&&courseItem.productType == 1">插班首次课时间：{{courseItem.insertLessonTimeText}}</div>
                            <div class="course_dot_line" v-else></div>

                            <div class="flex_box lesson_and_price_content">
                                <div class="flex_box" v-if="courseItem.teacherList && courseItem.teacherList.length >= 1">
                                    <div class="flex_box more_teacher_content"  v-for="(teacherinfo, index) in courseItem.teacherList.slice(0,2)" :key="index">
                                        <img class="teacher_icon" v-if="teacherinfo.newLogoUrl" :src="teacherinfo.newLogoUrl" onerror="javascript:this.src='https://cdn.xdf.cn/souke/h5-pages/components/teacher-info-card/images/default_teacher_photo.svg'"/>
                                        <img class="teacher_icon"  src="../../assets/cardteachericon.png" v-else/>
                                        <span class="teacher_name">{{teacherinfo.teacherName}}</span>
                                    </div>
                                    <div class="teacher_name" v-if="courseItem.teacherList && courseItem.teacherList.length > 2">...</div>
                                </div>
                                <div class="flex_box more_teacher_content" v-else>
                                    <img class="teacher_icon" src="../../assets/cardteachericon.png" />
                                    <span class="teacher_name">待定</span>
                                </div>

                                <div class="price_symbol_content">
                                    <span class="price_symbol">¥</span>
                                    <span class="course_price">{{courseItem.price}}</span>
                                </div>
                            </div>
                            <div class="select_icon">
                                <img v-if="courseItem.isSelect&&courseItem.registrationState!==6" src="../../assets/selectcourse.png" alt="">
                                <img v-else-if="courseItem.registrationState===6" src="../../assets/nocourse.png" alt="">
                                <img v-else src="../../assets/unselectcourse.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </v-reload>
            <!--底部按钮-->
            <div v-if="!isInIframe">
                <div class="activity_time" v-if="!isBeginActivity" :class="{activity_time_bottom: isIphoneX}">
                    活动将于{{beginTimeText}}开始
                </div>
                <div class="footer_content flex_box newfooter" :class="{footer_content_bottom: isIphoneX}">
                    <div class="leftside">
                        <a
                                class="call_phone flex_box_column"
                                v-if="phone.length > 0"
                                :href="!isIosApp ? 'tel:' + phone : 'javascript:;'"
                                @click="callPhone"
                        >
                            <img class="call_phone_icon" src="../../assets/callphoneicon.png" alt="">
                            <span class="call_phone_text">咨询</span>
                        </a>
                        <div
                                class="cartwrapper"
                                :class="{cartwrapper_left: phone.length === 0}"
                                @click="gotoShoppingCar"
                        >
                            <img class="call_phone_icon" src="../../assets/shopping.png" alt="">
                            <!-- :class="{ 'cart-count2': cartNumber.length >= 10 }" -->
                            <div
                                    v-show="cartNumber > 0"
                                    :class="{
                                'cart-count': cartNumber > 0,
                                'cart-count2': cartNumber >= 10
                            }"
                            >
                                {{ cartNumber }}
                            </div>
                            <span class="call_phone_text">购物车</span>
                        </div>
                    </div>
                    <div class="rightside">
                        <div class="addCart" @click="addCart">{{ cartList.length ? '加入购物车(' + cartList.length + ')' : '加入购物车' }}</div>
                        <div class="buy_course" @click="payMoney('baoming')">立即报名</div>
                    </div>
                    <!-- <div class="buy_course" @click="payMoney">{{ cartList.length ? '立即抢购(' + cartList.length + ')' : '请选择课程'}}</div> -->
                </div>
            </div>
        </div>

        <!--活动已结束-->
        <div v-if="isEndActivity">
            <end-activity></end-activity>
        </div>

        <!--弹窗-->
        <div class="filter_item_content_bg" v-if="isShowPopupList" @click="closePopupList">
            <div class="filter_item_content" id="_first">
                <div class="filter_item" v-for="(item, index) in filterTypeList" :key="index" @click="selectFilterItem(item, index)">
                    <div class="filter_item_line" v-if="selectTypeId !== '' && Number(selectTypeId) === index"></div>
                    <div class="filter_item_line_name tow" :class="{filter_item_line_name_color: selectTypeId === index}">{{item}}</div>
                </div>
            </div>
        </div>
        <div class="cart-error-mask" v-if="cartErrorText">
            <div class="cart-error-text">
                <h3>加购失败</h3>
                <div class="cart-error-wrap" v-html="cartErrorText">
                    <div class="error-item"></div>
                    <hr class="hr" />
                </div>
                <div @click="handleCartErrorText" class="handle-cart-error-text">知道了</div>
            </div>
        </div>
        <studentPopuper
            v-if="ispopshow"
            :show="ispopshow"
            :list="studentList"
            @closepop="closepop"
            @checkedCode="checkedCode"
        />
    </div>
</template>

<script>
    import wxSdk from "../../libs/wxsdk"
    import PullUpReload from '../../components/pullUpReload'
    import EndActivity from '../../components/endActivity'
    import {
        getNewMarketInfo,
        getMarketClassList,
        recordChannel,
        getMarketDimension,
        checkWxLogin,
        addCartApi,
        getCartCountApi,
        getStudentList,
        getGan
    } from '../../libs/api'
    import {
        formatDateUtil,
        teachingMethodUtil,
        getClassLessonTimesUtil,
        getClassStayUtil,
        isFewUtil,
        getIphoneXType,
        isWeChat,
        getUrlParam
    } from "../../libs/util"
    import studentPopuper from '../../components/studentPopuper'
    import { Indicator, Toast } from 'mint-ui'
    import Cookies from 'js-cookie'
    import configData from "../../libs/conf"
    import $ from 'jquery'
    export default {
        name:'newpackagelist',
        components: {
            'v-reload': PullUpReload,
            'end-activity': EndActivity,
            studentPopuper
        },
        metaInfo () {
            return {
                title: this.pageName
            }
        },
        data () {
            return {
                phone: '',
                pageName: '新东方专题活动',
                isShowPage: false, // 是否显示页面
                isFixedHeight: false, // 是否固定页面高度
                isShowPopupList:false, // 是否显示弹窗列表
                navList: [], // 导航栏
                filterTypeList: [], // 筛选列表
                selectTypeId: '', // 选中筛选类型的Id
                filterNum: '', // 1: 学校 2: 年级  3: 时间
                schoolName: '', // 校区名字
                gradeName: '', // 年级名字
                timeName: '', // 时间名字
                selectSchoolId: '', // 选中的学校Id
                selectGradeId: '', // 选中的校区Id
                selectTimeId: '', // 选中的时间Id
                navNumberList:[], // 导航栏的存在的数字
                navNumberShowString: '', // 导航栏的存在先显示的数字
                selectNavString: '', // 选择学校0，时间1，科目2，显示时间栏
                activityInfo: '', // 活动信息
                beginTimeText: '', // 活动开始时间文本
                isBeginActivity: true, // 是否开始活动
                isEndActivity: false, // 是否结束活动
                packageList: [], // 套餐列表
                activityId: 1, // 活动Id
                pageNumber: 1, // 当前页数
                pageSize: 5, // 一页多少个
                total: '',  // 总量
                pullUpState: 1, // 子组件的pullUpState状态
                cartList: [], // 购物车
                cartNumber: 0,
                cartErrorText: '', // 加购失败信息
                isShowPullUpFooter: true, // 是否显示加载更多底部
                U2AT:'', // token
                schoolId: '', // 学校Id
                isIosApp: false, // 是否是iosApp
                isIphoneX: false, // 是否iphoneX
                isLoadFull: false, // 是否加载完
                isWeChat: false, //  是否在微信环境内
                wxNickName: '', // 打点微信数据
                studentCode: '', // 加购学员信息
                studentName: '', // 加购学员姓名
                studentPhone: '', // 加购学员手机号
                ispopshow: false,
                studentList: [],
                agentName: '', // 邮箱或者手机号
                agn: '', // 推广渠道
                isInIframe: false  // 暂时只在推广中心使用
            }
        },
        created () {
            let hostname = top.location.hostname
            if (hostname == configData.promotion || hostname == configData.promotionTestOne || hostname == configData.promotionTestTwo || hostname == configData.promotionTestThree) {
                this.isInIframe = true
            }
        },
        mounted () {
            // 专题详情
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })

            let queryParams = this.$route.query
            if (queryParams.pageValue) {
                queryParams = getUrlParam(queryParams.pageValue)
            }
            // 获取标题参数
            let packageTitle = JSON.parse(sessionStorage.getItem('packageTitle'))
            if (!packageTitle) {
                packageTitle = queryParams
            }
            if (packageTitle) {
                this.schoolName = packageTitle.schoolName || ''
                this.selectSchoolId = packageTitle.selectSchoolId || ''
                this.gradeName = packageTitle.gradeName  || ''
                this.selectGradeId  = packageTitle.selectGradeId || ''
                this.timeName  = packageTitle.timeName || ''
                this.selectTimeId  = packageTitle.selectTimeId || ''
                this.filterNum = Number(packageTitle.filterNum) || ''
                this.activityId = packageTitle.activityId || ''
                this.channelId = packageTitle.channelId || ''
                this.agn = packageTitle.agn || ''
                this.selectNavString = packageTitle.selectNavString || ''
                if (packageTitle.selectSchoolId === 0) {
                    this.selectSchoolId = 0
                }
                if (packageTitle.selectGradeId === 0) {
                    this.selectGradeId = 0
                }
                if (packageTitle.selectTimeId === 0) {
                    this.selectTimeId = 0
                }
                // 存储title信息
                this.saveTitleInfo()
                switch(this.filterNum) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        break
                }
                // 打点数据
                gio('page.set',{
                    'activity_id': this.activityId,
                    'channel_id': this.channelId
                })
            }

            // 判断是否在微信环境内,是否授权
            this.isWeChat = isWeChat()
            // this.checkWxLogin()

            // 获取购物车数量
            this.cartList = sessionStorage.getItem('cartList') ? JSON.parse(sessionStorage.getItem('cartList')) : []
            // 获取纬度及课程列表
            this.getMarketInfo()
            this.getMarketClassList()
            this.getGan()

            // 大屏幕手机适配
            if ((window.screen.width === 375 && window.screen.height > 667) || (window.screen.width === 414 && window.screen.height > 667)) {
                $(".course_content_hidden").css("max-height", "1624")
            }

            // 是否在app内并且是ios
            if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
                this.isIosApp = true
            }

            // 判断是否IphoneX
            this.isIphoneX = getIphoneXType()
            // 后退刷新页面
            window.addEventListener('pageshow', (e) => {
                if (
                    e.persisted ||
                    (window.performance && window.performance.navigation.type == 2)
                ) {
                    window.location.reload()
                }
            }, false)
        },
        methods: {
            checkedCode (data) {
                this.studentCode = data.studentCodes[0].studentCode
                this.studentName = data.realName
                this.studentPhone = data.mobile
                this.ispopshow = false
                this.getAddcartApi()
            },
            closepop () {
                this.ispopshow = false
            },
            gotoShoppingCar () {
                this.payMoney(2)
            },
            getCartList () {
                getCartCountApi({
                    schoolId: this.activityInfo.schoolId,
                    appId: configData.appId
                }).then((res) => {
                    if (res.code === 10000) { // 成功
                        this.cartNumber = res.data
                    } else {
                        Toast({
                            message: '获取购物车信息失败',
                            duration: 2000,
                            className: 'noticeError'
                        })
                    }
                })
            },
            handleCartErrorText () {
                this.cartErrorText = ''
            },
            // 选择筛选选项
            selectSchoolType(num) {
                this.filterNum = num
                this.selectTypeId = ''
                this.isFixedHeight = true
                this.isShowPopupList = true
                switch(num) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        this.getMarketDimension(1)
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        this.getMarketDimension(2)
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        this.getMarketDimension(3)
                        break
                }
            },
            // 选择筛选列表
            selectFilterItem(itemName, itemIndex) {
                this.pullUpState = 1
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                })
                this.isFixedHeight = false
                this.isShowPopupList = false
                this.selectTypeId = itemIndex
                switch(this.filterNum) {
                    case 1: // 校区名字
                        this.selectSchoolId = itemIndex
                        this.schoolName = itemName
                        this.selectNavString = ''
                        if (this.selectNavString.indexOf('0') == -1) {
                            this.selectNavString += '0'
                        }
                        // 重新选择清空数据
                        this.selectGradeId = ''
                        this.gradeName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        break
                    case 2: // 年级名字
                        this.selectGradeId = itemIndex
                        this.gradeName = itemName
                        if (this.selectNavString.indexOf('1') == -1) {
                            this.selectNavString += '1'
                        }
                        // 重新选择清空数据
                        this.selectTimeId = ''
                        this.timeName = ''
                        break
                    case 3: // 时间名字
                        this.selectTimeId = itemIndex
                        this.timeName = itemName
                        break
                }
                // 统一调用
                this.saveTitleInfo()
                this.packageList = []
                this.pageNumber = 1
                this.getMarketClassList()
                this.getWxSdk()
            },
            // 存储标题参数
            saveTitleInfo () {
                // 存储学校名字
                let packageTitleInfo = {
                    schoolName: this.schoolName,
                    selectSchoolId: this.selectSchoolId,
                    gradeName: this.gradeName,
                    selectGradeId: this.selectGradeId,
                    timeName: this.timeName,
                    selectTimeId: this.selectTimeId,
                    filterNum: this.filterNum,
                    activityId: this.activityId,
                    channelId: this.channelId,
                    selectNavString: this.selectNavString,
                    agn: this.agn
                }
                sessionStorage.setItem('packageTitle', JSON.stringify(packageTitleInfo))
                // 在对接中心使用
                if (this.isInIframe) {
                    let iframeUrl = this.getHttpUrl()
                    window.location.replace(iframeUrl)
                }
            },
            // 关闭弹窗
            closePopupList() {
                this.isFixedHeight = false
                this.isShowPopupList = false
            },
            // 获取专题详情
            getMarketInfo() {
                getNewMarketInfo(this.activityId).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        let data = resData.data
                        this.activityInfo = data.activityinfo
                        let nowTime = new Date(this.activityInfo.nowTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTime = new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTimeText = formatDateUtil(new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800'), 'MM月dd日 HH:mm')
                        let endTime = new Date(this.activityInfo.endTime.replace(/-/g, '/') + '+0800').valueOf()
                        this.beginTimeText = beginTimeText
                        this.phone = this.activityInfo.connectPhone || ''
                        this.schoolId = this.activityInfo.schoolId
                        this.pageName = this.activityInfo.title

                        this.checkWxLogin()

                        // 活动未开始
                        if (nowTime < beginTime) {
                            this.isBeginActivity = false
                        }
                        // 活动已结束
                        if (nowTime > endTime) {
                            this.isEndActivity = true
                        }

                        // 标题列表
                        this.navList = data.navList
                        this.navList.forEach((navItem) => {
                            this.navNumberList.push(navItem.type)
                            if (navItem.type < 2) {
                                this.navNumberShowString += navItem.type
                            }
                        })
                        // 微信分享
                        this.getWxSdk()
                    }
                })
            },
            // 获取营销纬度
            getMarketDimension(num) {
                let data = {
                    activityId: this.activityId,
                    campusName: this.schoolName,
                    gradeName: this.gradeName,
                    classTime: ''
                }
                // 获取全部学校
                if (num === 1) {
                    data = {
                        activityId: this.activityId,
                        campusName: '',
                        gradeName: '',
                        classTime: ''
                    }
                }
                // 获取全部年级
                if (num === 2) {
                    data = {
                        activityId: this.activityId,
                        campusName: this.schoolName,
                        gradeName: '',
                        classTime: ''
                    }
                }
                getMarketDimension(data).then((res) => {
                    this.isFixedHeight = true
                    this.isShowPopupList = true
                    if (res.code == 1) {
                        let resData = res.data
                        if (num === 1) {
                            this.filterTypeList = resData.campusNameSet
                        } else if (num === 2) {
                            this.filterTypeList = resData.gradeNameSet
                        } else {
                            this.filterTypeList = resData.classTimeSet
                        }
                    }
                })
            },
            // 获取套餐列表
            getMarketClassList() {
                let data = {
                    campusName: this.schoolName,
                    gradeName: this.gradeName,
                    classTime: this.timeName,
                    activityId: this.activityId,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                }
                getMarketClassList(data).then((res) => {
                    Indicator.close()
                    let packageData = res.data
                    //套餐列表订单列表
                    this.pageNumber++
                    if (packageData.packageClassList) {
                        packageData.packageClassList.forEach( (packageItem) => {
                            packageItem.isSelectAll = false
                            let haveSelectCourse = []  // 已经选择的课程
                            let packageClassList = [] // 套餐下可买课程
                            packageItem.classList.forEach((classItem) => {
                                // 购物车有数量时要自动匹配
                                let index = this.cartList && this.cartList.indexOf(classItem.classCode)
                                if (this.cartList && index > -1) {
                                    // 用于套餐按钮的变化
                                    classItem.isSelect = true
                                    // this.selectCourse(packageItem, classItem)
                                } else {
                                    classItem.isSelect = false
                                }

                                // 套餐下可买课程
                                if (classItem.registrationState !== 6) {
                                    let index = packageClassList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        packageClassList.push(classItem.classCode)
                                    }
                                }

                                // 已选择课程加入
                                if (classItem.isSelect) {
                                    let index = haveSelectCourse.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        haveSelectCourse.push(classItem.classCode)
                                    }
                                }
                            })

                            if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                                packageItem.isSelectAll = true
                            }

                            if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                                packageItem.isSoldOut = true
                            }
                        })
                        this.packageList = this.packageList.concat(packageData.packageClassList)
                        if (this.packageList && this.packageList.length === 1 && this.packageList[0].classList.length <= 2) {
                            this.isShowPullUpFooter = false
                        } else {
                            this.isShowPullUpFooter = true
                        }
                    }
                    this.total = packageData.sum
                    this.isLoadFull = packageData.isFull
                    this.getStartPullUpState()
                })
            },
            // 获取上拉加载的pullUpState状态
            getStartPullUpState () {
                if (this.packageList.length) {
                    if (this.total <= this.pageSize) {
                        // 修改子组件的pullUpState状态
                        this.pullUpState = 3
                    } else {
                        this.pullUpState = 1
                    }
                } else {
                    this.pullUpState = 0
                }
            },
            // 上拉加载
            onInfiniteLoad (done) {
                // 数组小于2
                if (!this.isShowPullUpFooter) {
                    return
                }

                if (this.pullUpState === 1) {
                    this.getPullUpMoreData()
                }
                done()
            },
            // 上拉一次加载更多的数据
            getPullUpMoreData () {
                // 调用课程列表
                if (this.total === this.packageList.length || this.isLoadFull) {
                    this.pullUpState = 3
                } else {
                    this.pullUpState = 1
                    this.getMarketClassList()
                }
            },
            // 全部套餐
            selectAll (packageInfo) {
                if (packageInfo.isSoldOut) {
                    return
                }

                this.packageList.forEach((packageItem) => {
                    if (packageItem.packageCode === packageInfo.packageCode) {
                        if (packageItem.isSelectAll) {
                            packageItem.classList.forEach((classItem) => {
                                classItem.isSelect = false
                                let index = this.cartList.indexOf(classItem.classCode)
                                if (index > -1) {
                                    this.cartList.splice(index, 1)
                                }
                            })
                        } else {
                            packageItem.classList.forEach((classItem) => {
                                if (classItem.registrationState !== 6) {
                                    classItem.isSelect = true
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        this.cartList.push(classItem.classCode)
                                    }
                                }
                            })
                        }
                        packageItem.isSelectAll = !packageItem.isSelectAll
                    }
                })
                sessionStorage.setItem('cartList',JSON.stringify(this.cartList))
                // 验证相同班号
                if (!packageInfo.isSelectAll) {
                    this.verifyClassCode()
                }
            },
            // 单个课程
            selectCourse (packageInfo, course) {
                let haveSelectCourse = []  // 已经选择的课程
                let packageClassList = [] // 套餐下可买课程
                if(course.registrationState === 6) {
                    return
                }
                this.packageList.forEach((packageItem) => {
                    if (packageItem.packageCode === packageInfo.packageCode) {
                        packageItem.classList.forEach((classItem) => {
                            if (classItem.classCode === course.classCode) {
                                classItem.isSelect = !classItem.isSelect
                                if (classItem.isSelect) {
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        this.cartList.push(classItem.classCode)
                                        // 用于套餐按钮的变化
                                        // haveSelectCourse.push(classItem.classCode)
                                    }
                                } else {
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index > -1) {
                                        this.cartList.splice(index, 1)
                                        // 用于套餐按钮的变化
                                        packageItem.isSelectAll = false
                                    }
                                }
                            }

                            // 套餐下可买课程
                            if (classItem.registrationState !== 6) {
                                let index = packageClassList.indexOf(classItem.classCode)
                                if (index === -1) {
                                    packageClassList.push(classItem.classCode)
                                }
                            }

                            // 已选择课程加入
                            if (classItem.isSelect) {
                                let index = haveSelectCourse.indexOf(classItem.classCode)
                                if (index === -1) {
                                    haveSelectCourse.push(classItem.classCode)
                                }
                            }
                        })
                        // 循环结束判断是否全选
                        if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                            packageItem.isSelectAll = true
                        }

                        if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                            packageItem.isSoldOut = true
                        }
                    }
                })
                sessionStorage.setItem('cartList',JSON.stringify(this.cartList))
                // 验证相同班号
                if (!course.isSelect) {
                    this.verifyClassCode()
                }
            },
            // 验证相同班号
            verifyClassCode () {
                if (this.packageList) {
                    this.packageList.forEach( (packageItem) => {
                        packageItem.isSelectAll = false
                        let haveSelectCourse = []  // 已经选择的课程
                        let packageClassList = [] // 套餐下可买课程
                        packageItem.classList.forEach((classItem) => {
                            // 购物车有数量时要自动匹配
                            let index = this.cartList && this.cartList.indexOf(classItem.classCode)
                            if (this.cartList && index > -1) {
                                // 用于套餐按钮的变化
                                classItem.isSelect = true
                            } else {
                                classItem.isSelect = false
                            }

                            // 套餐下可买课程
                            if (classItem.registrationState !== 6) {
                                let index = packageClassList.indexOf(classItem.classCode)
                                if (index === -1) {
                                    packageClassList.push(classItem.classCode)
                                }
                            }

                            // 已选择课程加入
                            if (classItem.isSelect) {
                                let index = haveSelectCourse.indexOf(classItem.classCode)
                                if (index === -1) {
                                    haveSelectCourse.push(classItem.classCode)
                                }
                            }
                        })

                        if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                            packageItem.isSelectAll = true
                        }

                        if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                            packageItem.isSoldOut = true
                        }
                    })
                }
            },
            // 教学方式
            teachingMethod(methodCode) {
                return teachingMethodUtil(methodCode)
            },
            // 课时，课次
            getClassLessonTimes(lessonTimes, realMinutes) {
                return getClassLessonTimesUtil(lessonTimes, realMinutes)
            },
            // 住宿班
            getClassStay(modeCodes) {
                return getClassStayUtil(modeCodes)
            },
            // 名额紧张
            isFew(currentNum, maxNum, bmState) {
                return isFewUtil(currentNum, maxNum, bmState)
            },
            // 时间格式化
            formatDate(source, format) {
                return formatDateUtil(source, format)
            },
            // 记录渠道
            recordChannel() {
                let data = {
                    channelId: this.channelId,
                    u2at: this.U2AT,
                    wxNickname: this.wxNickName || '',
                    agn: this.agn || ''
                }
                recordChannel(data).then((res) => {
                    let reaData = res

                    if (reaData.code == 1 && reaData.data && reaData.data.userid) {
                        sessionStorage.setItem('userId', reaData.data.userid)
                        gio('setUserId', reaData.data.userid)
                    }
                })
            },
            // 登陆授权验证
            checkWxLogin(num, type) {
                checkWxLogin().then((res) => {
                    let reaData = res
                    let url = this.getHttpUrl()

                    // 微信授权
                    if (reaData.code == 4002 && this.isWeChat && !this.isInIframe) {
                        let wxLogin = configData.wxlogin
                        window.parent.location.href = wxLogin + '&returnUrl=' + encodeURIComponent(url)
                    }

                    if (reaData.code == 200 && reaData.data && this.schoolId) {
                        this.getCartList()
                    }

                    if (reaData.code == 200 && reaData.data && reaData.data.wxNickName) {
                        this.wxNickName = reaData.data.wxNickName
                    }

                    // 获取token
                    if (!num) {
                        this.U2AT = Cookies.get('U2AT')
                        let userId = sessionStorage.getItem('userId')
                        if (this.U2AT && !userId) {
                            this.recordChannel()
                        }
                    }

                    // 登录过期
                    if (num === 1) {
                        if (reaData.code == 4000) {
                            let urlLogin = configData.h5Login
                            window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                        } else {
                            if (type === 'addcart') {
                                // 加购逻辑
                                this.getStudent()
                                // this.getAddcartApi()
                            } else if (type === 2) {
                                // let classCodeList = this.cartList.join(",")
                                let marketingSource = this.activityId + '_' + this.channelId
                                if (this.agn) {
                                    marketingSource = this.activityId + '_' + this.agn
                                }
                                let marketingSourceExt = this.activityInfo.uniActivityId
                                let params = `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
                                    `&studentCode=${this.studentCode}&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`
                                window.parent.location.href = `${configData.h5Bm}/page-h5bm/cart?${params}`
                            } else {
                                let orderUrl = this.getOrderUrl()
                                window.parent.location.href = orderUrl
                            }

                        }
                    }
                })
            },
            getStudent () {
                getStudentList({
                    schoolId: this.schoolId,
                }).then((res) => {
                    if (res.code !== '200') {
                        console.log('没有学员信息')
                        this.getAddcartApi()
                    } else {
                        if (!res.data) {
                            // 无学员信息
                            this.getAddcartApi()
                        } else {
                            let data = res.data
                            if (data.length === 0) {
                                console.log('没有学员信息')
                                this.getAddcartApi()
                            } else if (data.length === 1) {
                                this.studentCode = data[0].studentCodes[0].studentCode
                                this.studentName = data[0].realName
                                this.studentPhone = data[0].mobile
                                this.getAddcartApi()
                            } else {
                                this.ispopshow = true
                                this.studentList = data
                            }
                        }
                    }
                })
            },
            addCart () {
                if (!this.isBeginActivity) {
                    Toast({
                        message: '当前活动还未开始哦~',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }
                if (this.cartList.length === 0) {
                    Toast({
                        message: '请选择报名产品',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                // 在app中去登陆
                if (xdfJs.xdfhybird.inApp) {
                    this.getAppToken()
                    return
                }

                if (this.U2AT) {
                    if (this.cartList && this.cartList.length === 0) {
                        return
                    }
                    // 已登陆
                    // this.recordChannel(1)
                    this.checkWxLogin(1, 'addcart') // 加一个type参数
                } else {
                    // 未登录
                    let urlLogin = configData.h5Login
                    window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(this.getHttpUrl())
                }
            },
            getAddcartApi () {
                addCartApi({
                    schoolId: this.schoolId,
                    goodsCode: this.cartList.join(","), //选择班级 已有
                    goodsType: 1,
                    studentCode: this.studentCode, // 获取学员号 xuehui提供
                    studentName: this.studentName, // 学员姓名
                    studentPhone: this.studentPhone, // 非必填
                    systemSource: configData.systemSource,
                    marketingSources: this.activityId + '_' + this.channelId,
                    marketingSourcesExt: this.channelId,
                    terminal: 2,
                    appId: configData.appId,
                }).then((res) => {
                    if (res.code === 10000) {
                        Toast({
                            message: '已加入购物车',
                            duration: 2000,
                            className: 'noticeError',
                            iconClass: 'noticeIcon'
                        })
                        // 加购完成，回调里  清空购物车 请求列表页
                        sessionStorage.setItem('cartList', '')

                        this.packageList.forEach( (packageItem) => {
                            packageItem.isSelectAll = false
                            packageItem.classList.forEach((classItem) => {
                                if (classItem.isSelect) {
                                    classItem.isSelect = false
                                }
                            })
                        })
                        this.cartList.length = 0

                        // this.getMarketClassList()
                        this.getCartList()
                    } else {
                        let cartErrorText = ''
                        if (res.message) {
                            const text = res.message.split('！')
                            if (text[1]) {
                                cartErrorText = text[1].replace(/。$/, '').replace(/。/g, '</div><hr /><div>').replace(/～/g, '<br />').replace(/~/g, '<br />')
                            } else {
                                cartErrorText = text[0]
                                // that.popup(data.Error);
                            }
                            this.cartErrorText = '<div>' + cartErrorText + '</div>'
                        }
                        sessionStorage.setItem('cartList', '')

                        this.packageList.forEach( (packageItem) => {
                            packageItem.isSelectAll = false
                            packageItem.classList.forEach((classItem) => {
                                if (classItem.isSelect) {
                                    classItem.isSelect = false
                                }
                            })
                        })
                        this.cartList.length = 0
                        this.getCartList()
                    }
                })
            },
            payMoney(num) {
                if (!this.isBeginActivity) {
                    Toast({
                        message: '当前活动还未开始哦~',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                if (this.cartList.length === 0 && num === 'baoming') {
                    Toast({
                        message: '请选择报名产品',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                // 在app中去登陆
                if (xdfJs.xdfhybird.inApp) {
                    this.getAppToken()
                    return
                }

                if (this.U2AT) {
                    if (this.cartList && this.cartList.length === 0 && num === 'baoming') {
                        return
                    }
                    // 已登陆
                    if (num === 2) {
                        this.checkWxLogin(1, 2)
                    } else {
                        this.checkWxLogin(1)
                    }
                } else {
                    // 未登录 直接跳转到订单页面
                    let urlLogin = configData.h5Login
                    let url = this.getOrderUrl()
                    window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                }
            },
            // 获取app的token
            getAppToken() {
                xdfJs.xdfhybird.getUser( (data) => {
                    // 判断用户是否登陆
                    if (
                        data &&
                        data.user &&
                        !!data.user.userId &&
                        data.user.userId.length > 0
                    ) {
                        let token = data["user"]["accessToken"]
                        this.U2AT = token
                        Cookies.set('U2AT', token, { expires: 30, domain: 'xdf.cn' })
                        this.recordChannel()
                        // 跳转到支付
                        let url = this.getOrderUrl()
                        if (token) {
                            xdfJs.xdfhybird.openURL("xdfapp://student/web", {"url": url})
                        }
                    } else {
                        xdfJs.xdfhybird.openURL("xdfapp://student/login", {})
                    }
                })
            },
            // 微信分享
            getWxSdk() {
                let shareObj = {
                    urlLogo: this.activityInfo.shareUrl || '' ,// 分享图标
                    desc: this.activityInfo.shareDesc || ''
                }

                shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title
                let params = this.getParams()
                shareObj.link = configData.originUrl + 'newpackage/list?pageValue=' + encodeURIComponent(params)
                wxSdk.getWxSdk(shareObj)
            },
            // 获取跳转参数
            getParams() {
                let params = `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}` +
                    `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`
                return params
            },
            // 获取分享链接
            getHttpUrl() {
                let httpUrl = configData.originUrl + 'newpackage/list?'
                let params = this.getParams()
                let url =  httpUrl + params
                return url
            },
            // ios内打电话
            callPhone() {
                if (!this.isIosApp) {
                    return
                }
                xdfJs.xdfhybird.loadPlugin("XDFHybirdCallPhonePlugin")
                xdfJs.xdfhybird.callPlugin("XDFHybirdCallPhonePlugin", "callPhone", {
                    number: Number(this.phone)
                })
            },
            // 获取新的渠道参数agn
            getGan() {
                if(this.$route.query.agentName){
                    this.agentName = this.$route.query.agentName
                    return
                }
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                })
                // 专题详情
                let data = {
                    activityId: this.activityId,
                    agn: this.agn
                }
                getGan(data).then((res) => {
                    Indicator.close()
                    let resData = res
                    if (resData.code == 1) {
                        this.agentName = resData.data.agentName
                    }
                }).catch(err => {
                    Indicator.close()
                })
            },
            // 提取订单URl
            getOrderUrl() {
                let classCodeList = this.cartList.join(",")
                let marketingSource = this.activityId + '_' + this.channelId
                if (this.agn) {
                    marketingSource = this.activityId + '_' + this.agn
                }
                let marketingSourceExt = this.activityInfo.uniActivityId
                let params = `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
                    `&classCodes=${classCodeList}&studentCode=${this.studentCode}&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`
                let orderUrl = `${configData.h5Bm}/page-h5bm/order?${params}`
                return orderUrl
            }
        }
    }
</script>

<style lang="less" scoped>
    .course_list_content {
        padding-bottom: 100px;
        .title_content {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 98px;
            padding-top: 32px;
            padding-bottom: 24px;
            justify-content: space-around;
            background: #fff;
            z-index: 999;
            .title_name_content {
                .title_name {
                    font-size:30px;
                    color:rgba(51,51,51,1);
                    line-height:42px;
                    margin-right: 12px;
                    max-width: 120px;
                    text-align:center;
                }
                .down_arrow_icon {
                    width: 16px;
                    height: 14px;
                }
                .title_name_color {
                    color:rgba(31,184,149,1);
                }
            }
        }
        .title_content_left {
            justify-content: flex-start;
            padding-left: 32px;
        }

        // 一级筛选框
        .filter_item_content_bg {
            position: fixed;
            z-index: 10000;
            left: 0;
            right: 0;
            top: 98px;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            .filter_item_content {
                width: 100%;
                position: absolute;
                z-index: 100;
                background: white;
                max-height: 80%;
                min-height: 20%;
                overflow: auto;
                .filter_item {
                    height: 102px;
                    width: 100%;
                    line-height: 102px;
                    .filter_item_line_name {
                        width: 80%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: 102px;
                        padding-left: 40px;
                        line-height: 102px;
                        font-size:30px;
                        color: #333;
                    }

                    .filter_item_line {
                        float: left;
                        height: 100%;
                        width: 8px;
                        background: linear-gradient(180deg, rgba(88, 213, 126, 1) 0%, rgba(40, 207, 185, 1) 100%);
                    }

                    .filter_item_line_name_color {
                        color: #1fb895;
                    }
                    .filter_item_line_none {
                        display: none;
                    }
                }
            }
        }
    }
    .course_list_content_top {
        padding-top: 98px;
    }
    .course_content_bottom {
        padding-bottom:170px;
    }
    .course_content_bottom_iphoneX {
        padding-bottom:168px;
    }
    .package_title_style {
        margin-bottom: 40px !important;
    }
    .detail_style {
        margin-top: 0 !important;
        margin-bottom: 32px !important;
    }
    .add_style {
        margin-top: 8px;
    }
    .select_all {
        width: 170px !important;
    }
    .newfooter {
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100px;
        padding-left: 50px;
        padding-right: 12px;
        background: #fff;
        justify-content: space-between;
        box-shadow:0 6px 20px 0 rgba(206,223,241,0.7);
        .leftside {
            display: flex;
            .call_phone {
                display: block;
                .call_phone_icon {
                    width: 40px;
                    height: 40px;
                    margin-top: 10px !important;
                    margin-bottom: 0 !important;
                }
                .call_phone_text {
                    display: block;
                    margin-top: 4px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #666;
                }
            }
            // align-items: center;
            .cartwrapper {
                margin-left: 38px;
                position: relative;
                img {
                    margin-left: 10px;
                }
                .cart-count {
                    position: absolute;
                    top: -5px;
                    right: -5px;
                    width: 30px;
                    height: 30px;
                    background: linear-gradient(180deg, #ff371a, #ff692b);
                    box-shadow: 0px 1px 3px 0px rgba(255, 135, 15, 0.5);
                    border-radius: 50%;
                    text-align: center;
                    line-height: 30px;
                    color: #fff;
                    font-size: 22px;
                }
                .cart-count2 {
                    font-size: 20px;
                }
                .call_phone_icon {
                    width: 40px;
                    height: 36px;
                    margin-top: 10px !important;
                    margin-bottom: 0 !important;
                }
                .call_phone_text {
                    display: block;
                    margin-top: 4px;
                    font-size:20px;
                    line-height:28px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .cartwrapper_left {
                margin-left: 0;
            }
        }
        .rightside {
            width: 440px;
            border-radius: 40px;
            display: flex;
            font-size: 28px;
            overflow: hidden;
            .addCart {
                width: 220px;
                background: linear-gradient(270deg, #ff9b19 0%, #ffb93c 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 28px;
            }
            .buy_course {
                width: 220px;
                background: linear-gradient(90deg,rgba(255,95,40,1) 0%,rgba(255,105,43,1) 100%);
                border-radius: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 28px;
            }
            // .buy_course {
            //     width:300px;
            //     height:80px;
            //     background:linear-gradient(90deg,rgba(255,95,40,1) 0%,rgba(255,105,43,1) 100%);
            //     border-radius: 200px;
            //     font-size:32px;
            //     color:rgba(255,255,255,1);
            //     line-height:80px;
            //     text-align: center;
            //     font-weight: normal;
            // }
        }
    }
    .footer_content_bottom {
        height: 146px;
        padding-bottom: 46px;
    }
    .cart-error-mask {
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, .7);
        position: fixed;
        z-index: 98;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cart-error-text {
        width: 590px;
        // max-height: 66vh;
        background: #fff;
        border-radius: 20px;
        font-size: 28px;
        // position: fixed;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -60%);
        z-index: 98;
        h3 {
            font-size: 40px;
            line-height: 56px;
            margin: 0;
            padding: 44px 0 24px 0;
            text-align: center;
        }
        .cart-error-wrap {
            line-height: 48px;
            padding: 0 36px 0 30px;
            color: #1e1e1e;
            overflow-y: scroll;
            max-height: 50vh;
            font-weight: 300;
            /deep/ div {
                padding-left: 36px;
                background: url('../../assets/warning.svg')  no-repeat 0 8px;
                background-size: 28px 28px;
            }
            /deep/ hr {
                border: 0;
                height: 1px;
                margin: 30px 0;
                background: #e3e3e3;
            }
        }
        .handle-cart-error-text {
            height: 90px;
            line-height: 90px;
            margin-top: 34px;
            border-top: 1px solid #e3e3e3;
            font-size: 32px;
            color: #1fb895;
            text-align: center;
        }
    }
</style>
